import * as axios from 'axios';
import { useUserStore } from '../store/useUser';
import { environment } from '../environment';
import { refreshToken } from './auth';
import { useApiStore } from '../store/useApi';
import { useSidebarStore } from '../store/useSidebar';

const api = axios.default.create({
    baseURL: environment.api.baseUrl,
});

api.interceptors.request.use(async (config) => {
    const token = useUserStore.getState()?.jwt?.access_token

    if (token) {
        (config.headers! as unknown as any).common['Authorization'] = 'Bearer ' + token;
        useUserStore.destroy()
        return config;
    }

    return config;
});


api.interceptors.response.use((response) => {
    return response;
}, async function (error) {
    const originalRequest = error.config;

    //Sem permissão
    if (error.response.status === 403) {
        localStorage.clear();
        window.location.href = '/login';
        return Promise.reject(error);
    }

    if (error.response.status === 401 && originalRequest._retry) {
        localStorage.clear()
        return Promise.reject(error);
    }

    //Token Invalido
    if (error.response.status === 401 && !originalRequest._retry) {
        if (useApiStore.getState().refreshTokenIsLoading) return

        const refresh_token = useUserStore.getState()?.jwt?.refresh_token
        
        if (!refresh_token) {
            useUserStore.getState().reset()
            useSidebarStore.getState().setMenu()

            return Promise.reject(error);
        }

        useApiStore.getState().setRefreshTokenIsLoading(true)

        const { error: errorJwt, success: jwt } = await refreshToken();

        useApiStore.getState().setRefreshTokenIsLoading(false)

        if (errorJwt || !jwt) {
            localStorage.clear()
            return Promise.reject(error);
        }

        originalRequest._retry = true;

        return api(originalRequest);
    }

    return Promise.reject(error);
}
)

export default api;